import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { advisorAdminApi } from '../api/api';

type UpdateContactInfoParams = {
  advisorId: string;
  advisorFieldKey: 'advisorEmail' | 'advisorPhoneNumber';
  advisorFieldValue: string;
};

export function useUpdateContactInfo() {
  const mutation = useMutation({
    mutationFn: ({ advisorId, advisorFieldKey, advisorFieldValue }: UpdateContactInfoParams) =>
      advisorAdminApi.updateAdvisorAccountIdentifier(advisorId, {
        advisorFieldKey,
        advisorFieldValue,
      }),
    onSuccess: (data) => {
      toast.success(typeof data === 'string' ? data : 'Contact info updated successfully');
    },
  });

  return {
    updateContactInfo: mutation.mutateAsync,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
}
